<script>
import { Bar } from "vue-chartjs";
import dayjs from 'dayjs';
export default {
	name: "BarChart",
	extends: Bar,
	props: {
		data: {
			required: true,
		},
		statType: {
			type: String,
			required: false,
		},
	},
	data() {
		return {};
	},
	mounted() {
		this.updateData();
	},
	methods: {
		updateData() {
			let d = [];
			let labels = [];
			this.data.forEach(dd => {
				d.push(dd.value);
				labels.push(dayjs(dd.date).format('DD MMM YYYY'))
			})
			
			let maxData = Math.max(...d);
			
			let label = this.statType === 'earning' ? 'Euro' : '';
			
			this.renderChart(
				{
					datasets: [
						{
							label: label,
							data: d,
							backgroundColor: "#2a9cb1",
							fill: true,
							maxBarThickness: 60
						},
					],
					labels: labels,
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						display: false,
					},
					scales: {
						yAxes: [
							{
								ticks: {
									stepSize: 1,
									precision: 0,
									beginAtZero: true,
								},
							},
						],
					},
				}
			);
		},
	},
	watch: {
		data: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
	},
};
</script>
